import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../lib/api";

export function AdminDashboardPage() {
    const { t } = useTranslation();
    const [stats, setStats] = useState({ events: 0, bookings: 0, payouts: 0 });

    useEffect(() => {
        (async () => {
            try {
                const [e, b, p] = await Promise.all([
                    api.get("/api/admin/events"),
                    api.get("/api/admin/bookings"),
                    api.get("/api/admin/payouts"),
                ]);
                setStats({
                    events: (e.data || []).length,
                    bookings: (b.data || []).length,
                    payouts: (p.data || []).filter((x) => x.status === "pending").length,
                });
            } catch {}
        })();
    }, []);

    return (
        <div data-testid="admin-dashboard" className="space-y-6">
            <h1 className="font-heading font-black text-3xl">{t("admin.dashboard")}</h1>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="stats-card">
                    <div className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">{t("admin.events")}</div>
                    <div className="font-heading font-black text-3xl mt-2">{stats.events}</div>
                </div>
                <div className="stats-card">
                    <div className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">{t("admin.bookings")}</div>
                    <div className="font-heading font-black text-3xl mt-2">{stats.bookings}</div>
                </div>
                <div className="stats-card">
                    <div className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">{t("admin.payouts_pending")}</div>
                    <div className="font-heading font-black text-3xl mt-2">{stats.payouts}</div>
                </div>
            </div>
        </div>
    );
}
